import * as React from "react";
import { cn } from "@/shared/lib/utils";

interface IFilterButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    active: boolean
    className?: string,
}

const FilterButton = React.forwardRef<HTMLButtonElement, IFilterButtonProps>(
    ({children, active, className, ...props }, ref) => {

        const [pressed, setPressed] = React.useState<boolean>(false);
        const [hovered, setHovered] = React.useState<boolean>(false);

        return (
            <button
                ref={ref}
                className={cn(
                    "bg-white h-[36px] font-manrope text-[12px] md:text-[14px] font-medium rounded-[10px] flex justify-center items-center",
                    className,
                    hovered && "bg-main-grey",
                    (pressed || active) && "bg-light-blue"
                )}
                {...props}
                onMouseDown={()=>setPressed(true)}
                onMouseUp={()=>setPressed(false)}
                onMouseEnter={()=>setHovered(true)}
                onMouseLeave={()=>{setPressed(false); setHovered(false)}}
                
                onTouchStart={()=>setPressed(true)}
                onTouchEnd={()=>setPressed(false)}
            >

                {children}
            </button>
        );
    }
);

FilterButton.displayName = "FilterButton";

export default FilterButton;